import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './scss/style.scss';
import Vuex from 'vuex'
import VueAxios from 'vue-axios'
import axios from 'axios';
import VueMatomo from 'vue-matomo';
import VueScrollTo from 'vue-scrollto';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Notifications from 'vue-notification'
import VueRouterBackButton from 'vue-router-back-button'
import appConfig from './config/appConfig';
// import './scss/style-rtl.scss';


// import "vue-select/dist/vue-select.css";

Vue.config.productionTip = true;
Vue.prototype.modals = true;
export const bus = new Vue({});

/*config*/
/*id of the current app*/
Vue.prototype.$appId = appConfig.appId;
Vue.prototype.$appName = appConfig.appName;
Vue.prototype.$institutionId = appConfig.institutionId;
Vue.prototype.$ratgeberId = appConfig.ratgeberId;
Vue.prototype.$kitaId = appConfig.kitaId;
Vue.prototype.$schulId = appConfig.schulId;
Vue.prototype.$offerId = appConfig.offerId;
Vue.prototype.$city = appConfig.city;
Vue.prototype.$backendUrl = appConfig.backendUrl;
Vue.prototype.$backendApiUrl = appConfig.backendApiUrl;
Vue.prototype.$impressumContentId = appConfig.impressumContentId;
Vue.prototype.$datenschutzContentId = appConfig.datenschutzContentId;
Vue.prototype.$barrierefreiheitsContentId = appConfig.barrierefreiheitsContentId;
Vue.prototype.$shortDescriptionWordCount = appConfig.shortDescriptionWordCount;
Vue.prototype.$hideUserAccountRelatedFunctions = appConfig.hideUserAccountRelatedFunctions;
Vue.prototype.$loginForProvidersUrl = appConfig.loginForProvidersUrl;
Vue.prototype.$loginForProvidersBaseUrl = appConfig.loginForProvidersBaseUrl;

Vue.use(Vuex);
Vue.use(VueScrollTo);
Vue.use(Notifications);
Vue.use(VueAxios, axios);
Vue.use(VueRouterBackButton, { router });

/*Initialisieren von Loading*/
Vue.use(Loading, {
  color: 'rgb(148, 192, 31)',
  loader: 'dots',
  width: 140,
  FullPage: true
});

Vue.use(VueMatomo, {
  host: appConfig.matomoHost,
  siteId: appConfig.matomoSiteId,
  trackerFileName: 'matomo',
  router: router,
  enableLinkTracking: true,
  requireConsent: false,
  trackInitialView: true,
  disableCookies: false,
  enableHeartBeatTimer: false,
  heartBeatTimerInterval: 15,
  debug: false,
  userId: undefined,
  cookieDomain: undefined,
  domains: undefined,
  preInitActions: []
});

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
